import { render, staticRenderFns } from "./newRequestIcon.vue?vue&type=template&id=53f9f7d2&scoped=true"
import script from "./newRequestIcon.vue?vue&type=script&lang=js"
export * from "./newRequestIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53f9f7d2",
  null
  
)

export default component.exports